// Borde kanske slå ihop Month och Day? Liknar väldigt mycket ListItem modellen.
export class Month {
  private static readonly months: Month[] = [
    {text: 'Januari', value: '1', disabled: false},
    {text: 'Februari', value: '2', disabled: false},
    {text: 'Mars', value: '3', disabled: false},
    {text: 'April', value: '4', disabled: false},
    {text: 'Maj', value: '5', disabled: false},
    {text: 'Juni', value: '6', disabled: false},
    {text: 'Juli', value: '7', disabled: false},
    {text: 'Augusti', value: '8', disabled: false},
    {text: 'September', value: '9', disabled: false},
    {text: 'Oktober', value: '10', disabled: false},
    {text: 'November', value: '11', disabled: false},
    {text: 'December', value: '12', disabled: false}
  ];

  text: string;
  value: string;
  disabled: boolean;

  constructor(name: string, value: string, disabled = false) {
    this.text = name;
    this.value = value;
    this.disabled = disabled;
  }

  public static createMonths(): Month[] {
    return this.months.map((m: Month) => new Month(m.text, m.value, m.disabled));
  }
}

export class Day {
  text: string;
  value: string;
  disabled: boolean;

  constructor(text: string, value: string, disabled = false) {
    this.text = text;
    this.value = value;
    this.disabled = disabled;
  }

  public static createDays(days: number): Day[] {
    const listOfDays: Day[] = [];
    for (let i = 1; i <= days; i++) {
      listOfDays.push(new Day(i.toString(), i.toString()));
    }
    return listOfDays;
  }
}
